/* eslint-disable default-param-last */
/* eslint-disable no-case-declarations */
const initialState = {
  permissionsNewUSer: [{}],
};

const permissionNewUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE-LIST-PERMISSIONS':
      const permissions = action.payload.map((item) => {
        const permission = {};
        item.nameObjt.checkboxs.forEach((i) => {
          const permissionKey = Object.keys(i.domainPermission)[0];
          const permissionValue = i.domainPermission[permissionKey];
          permission[permissionKey] = permissionValue;
        });
        return permission;
      });
      return {
        ...state,
        permissionsNewUSer: permissions,
      };

    default:
      return state;
  }
};

export default permissionNewUserReducer;
